import { PageHeader } from 'components/page-header/page-header'
import { theme } from 'antd'
import { setCacheManually, useTranslate, useWindowDimensions } from 'utils'
import { PageContentWrapper, VerticalContainer } from 'components/styled'
import { PlusOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useConfig, useInstalledApps } from 'api'
import { Feature } from 'types'
import { FormSection } from 'components/form-section/form-section'
import { VerticalPaginatedList } from 'components/vertical-paginated-list/vertical-paginated-list'
import { InstalledAppItem } from 'components/app/installed-app-item/installed-app-item'

export const InstalledAppsList = () => {

    //hooks:
    const { token: { padding, paddingMD, marginXXS, margin } } = theme.useToken()
    const { SM } = useWindowDimensions()
    const { data: config } = useConfig()
    const { __ } = useTranslate()
    const navigate = useNavigate()

    //state:
    const [ search, setSearch ] = useState<string | null>(null)

    //installed apps:
    const {
        data: apps,
        pageNum,
        totalPages,
        isLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useInstalledApps(search)

    // redirect if it doesn't have access to apps:
    useEffect(() => {
        if(config){
            if(!config.features.includes(Feature.APPS)){
                navigate('/')
            }
        }
    }, [config])

    return (
        <PageContentWrapper>

            <VerticalContainer style={{ gap: SM ? margin : marginXXS }}>

                {/* header */}
                <PageHeader
                    title={__`apps`}
                    description={__`manage_all_your_installed_apps`}
                    primaryButton={{
                        name: __`install_app`,
                        icon: <PlusOutlined/>,
                        onClick: () => navigate('/app/all')
                    }}
                />

                <div style={{ padding: SM ? `0 ${padding}px` : 0 }}>

                    <FormSection
                        title={SM ? __`installed_apps` : undefined }
                        childrenWrapperStyle={{ padding: SM ? `0 ${paddingMD}px` : 0 }}
                        searchInput={{
                            placeholder: __`search_apps`,
                            onSearch: setSearch
                        }}
                    >

                        {/* list */}
                        <VerticalPaginatedList
                            isFirstLoading={isLoading}
                            isForbidden={apps === null}
                            isError={false}
                            notFound={(apps && apps.length === 0) ?? false}
                            totalPages={totalPages}
                            pageNum={pageNum}
                            isPreviousData={isPreviousData}
                            isNextDisabled={isNextDisabled}
                            isPreviousDisabled={isPreviousDisabled}
                            fetchNext={fetchNext}
                            fetchPrevious={fetchPrevious}
                        >
                            
                            {apps && apps.map(app => (
                                <InstalledAppItem
                                    key={app.id}
                                    app={app}
                                    onClick={() => {
                                        setCacheManually(['app', app.id], app)
                                        navigate(`/app/${app.id}`)
                                    }}
                                />
                            ))}

                        </VerticalPaginatedList>

                    </FormSection>

                </div>

            </VerticalContainer>

        </PageContentWrapper>
    )
    
}
